import request from "@/utils/request";
import reConfig from "@/constants/releaseConfig";
let apiDomain =
	location.origin.indexOf("pycoding.com") == -1 ? "" : "//app.yatiku.com";
export function getUserInfo(code, accid) {
	let params = {
		accid,
	};
	if (code) {
		params.code = code;
	}
	// 只针对pycoding.com域名
	return request(apiDomain)
		.post("/activity/getUserInfo", params)
		.then((res) => {
			if (res.code == 200) {
				localStorage.accid = res.data.accid;
				localStorage.setItem('buriedPoint', JSON.stringify(res.data));
			}
			return res;
		});
}
export function getAccid(activityId) {
	return request("").post("/activity/helping/getActivityAccInfo", {
		activityId,
	});
}
// 获取用户的详细信息
export function getUserAllInfo() {
	// 只针对pycoding.com域名
	let apiDomain =
		location.origin.indexOf("pycoding.com") == -1
			? ""
			: "//app.yatiku.com";
	return request(apiDomain).post("/activity/getUserAllInfo");
}
export function getAppid(accId) {
	// 只针对pycoding.com域名
	let apiDomain =
		location.origin.indexOf("pycoding.com") == -1
			? ""
			: "//app.yatiku.com";
	return accId
		? request(apiDomain).post("/activity/getApAc", {
				accId,
		  })
		: "";
}
// 获取验证码
export function sendCode(tel, validateCode) {
	return request("").post("/tool/sendmsgbind", {
		tel,
		validateCode,
	});
}

// 获取成绩单
export function tranScript(itemUserId) {
	return request().post("/teaching/affairs/user/firstScoreByItemUserId", {
		itemUserId,
	});
}
export const writeCookie = () => {
	// 做了兼容，针对测试服跟正式服以及pycoding.com
	let apiDomain =
		location.origin.indexOf("pycoding") == -1
			? `${location.origin}/app/v1`
			: "//app.yatiku.com/app/v1";
	request(apiDomain).post("/tool/writeCookie", {
		clientType: reConfig.clientType,
		clientVersion: reConfig.clientVersion,
		brandType: reConfig.brandType,
	});
};
// 根据活动id获取二维码
export function getCodeImgByGroup(shareId) {
	return request("").post("/app/getShareActivityIdByRecode", {
		shareId,
	});
}

// 填补物流：获取物流信息
export function fillAddressGetInfo(openId) {
	return request("").post("/wx/getUserOrderInfoNew", {
		OpenId: openId,
	});
}
// 填补物流：获取物流信息
export function fillAddressUpdateAddress(obj) {
	return request("").post("/wx/edUserOrderInfoAddress", obj);
}
// 填补物流：活动分享参数
export function getFillAddressShareInfo(id) {
	return request("").post("/app/findShareActivityById", {
		id,
	});
}
export function getExpress(postNumber) {
	return request("").post("/adminajax/adminOrder/getThisPayOrderPostLoading", {
		postNumber,
	});
}
// 填补地址：修改地址
export function editAddress(obj) {
	return request("").post("/wx/edUserOrderInfoAddress", obj);
}
// 填补地址：交换地址
export function exchangeUserId(tel, openid) {
	return request("").post("/wx/getUserId", {
		tel,
		openid,
	});
}
export function createWxOrderByMoney(params) {
	return request("").get("/activity/payProduct/createWxOrderByMoney", params);
}
// 获取手机验证码
export const sendCodeMsgByTmall = (tel, openid) =>
	request("/app/v1/tool").post("/sendCodeMsgByTmall", {
		tel,
		openid,
	});

// 获取公众号二维码
export const accCode = (accId) =>
	request("/activity").get("/getQRCodeById", {
		accId,
	});

// 发送验证码短信
export const sendMsgCode = (validateCode, tel, openid) =>
	request("/app/v1").post("/tool/sendmsgbind_Mini", {
		validateCode,
		tel,
		openid,
	});

/**
 * 获取全局操作凭证token
 */
export function getAccessToken() {
	let sendData = {
		access_token: localStorage.getItem("access_token") || "",
		brandType: reConfig.brandType,
		clientType: reConfig.clientType,
		clientVersion: reConfig.clientVersion,
	};
	let requestUrl =
		process.env.NODE_ENV === "developement"
			? "//dev.yatiku.com"
			: "//app.yatiku.com";
	request(requestUrl)
		.post("/app/v1/getAccessToken", sendData)
		.then((res) => {
			if (res.code == 200) {
				localStorage.setItem("access_token", res.data.token);
			}
		});
}

export const getAllAddressList = () =>
	request("/").get("app/getAllAddressList");


// 得到值
export function redisGet(params) {
	return request("").get("/redis/get", params);
}

// 假用户数据接口
export function fakeUsers(params) {
	return request("").get("/api/portal/exam_tips/plan/lottery/barrage", params);
}

// 在线获取人数
export function getTotalNum(params) {
	return request("").get("/activity/queryScoreAjax/findQueryScoreListSize", params);
}

// 假用户数据接口
export function getRandomUser(params) {
	return request("").get("/activity/wx/user/getRandomUser", params);
}


// WEBPACK FOOTER //
// ./src/api/app.js